import { IS_CAMPER } from './constants';

export const FilterSVG = (props) => (
  <svg height={13} viewBox="0 0 16 13" width={16} {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="m0 2.5h16" stroke="#000" />
      <path d="m0 10.5h16" stroke="#000" />
      <g fill="#000">
        <path d="m12 0h1v5h-1z" />
        <path d="m3 7.973684h1v5h-1z" />
      </g>
    </g>
  </svg>
);

export const filtersMockup = [
  {
    title: 'whats.new',
    id: 'collections',
    mockup: true,
    options: [
      { label: 'Top Sellers', value: 'bestseller' },
      { label: 'Gore-Text', value: 'goretex' },
    ],
  },
  {
    title: 'Tipo',
    id: 'typologies',
    mockup: true,
    options: [
      { label: 'Zapato casual', value: 'casual' },
      { label: 'Zapato de vestir', value: 'casual' },
      { label: 'Sneakers', value: 'casual' },
      { label: 'Botines', value: 'casual' },
      { label: 'Non leather', value: 'casual' },
    ],
  },
  {
    title: 'Lineas',
    id: 'concepts',
    mockup: true,
    options: [
      { label: 'Beetle', value: 'beetle' },
      { label: 'Pelotas', value: 'pelotas' },
      { label: 'Peu', value: 'peu' },
      { label: 'Twins', value: 'twins' },
    ],
  },
  {
    // mirar esto a ver qué podemos hacer que ahora es un caos
    // y cada vez que se cambia una key del back peta todo
    title: 'Línea',
    id: 'lineCollections',
    mockup: true,
    options: [
      { label: 'Beetle', value: 'beetle' },
      { label: 'Pelotas', value: 'pelotas' },
      { label: 'Peu', value: 'peu' },
      { label: 'Twins', value: 'twins' },
    ],
  },
  {
    title: 'Talla',
    id: 'sizes',
    mockup: true,
    options: [
      { label: '37', value: '37' },
      { label: '38', value: '38' },
      { label: '39', value: '39' },
    ],
  },
  {
    title: 'Color',
    id: 'colors',
    mockup: true,
    options: [
      { label: 'Negro', value: 'C01' },
      { label: 'Blanco', value: 'C02' },
      { label: 'Rosa', value: 'C04' },
    ],
  },
  {
    title: 'Precio',
    id: 'prices',
    mockup: true,
    options: [
      { label: '0 - 140€', value: '?' },
      { label: '0 - 170€', value: '?' },
    ],
    solo: true,
  },
  {
    title: 'Sostenibilidad',
    id: 'sustainabilities',
    options: [],
  },
  {
    title: 'Discounts',
    id: 'discounts',
    options: [],
  },
  {
    title: 'Performances',
    id: 'performances',
    options: [],
  },
  {
    title: 'discount.collecction',
    id: 'discountCollections',
    options: [],
    solo: true,
  },
  {
    title: 'Targets',
    id: 'targets',
    options: [],
  },
  {
    title: 'Families',
    id: 'families',
    options: [],
  },
];
// de donde habra que sacar esto? de la api de traducciones o de las labels de la api de productos?
export const labels = {
  prices: [
    '0 - 140 €',
    '140 - 170 €',
    'More than 170',
  ],
  sustainabilities: [
    'Recycled styles',
    'Better cotton',
    'Tencel',
    'Better leather',
    'Lifetime guarantee',
    'Better outsoles',
    'Chrome-free linings',
    'Wool',
  ],
};

export const sorts = {
  default: IS_CAMPER ? 'ordenar.camper' : 'ordenar.nnormal',
  price_asc: 'ordenar.precio.min.max',
  price_desc: 'ordenar.precio.max.min',
};

export const filterGrid = {
  novelties: { gutter: 16, column: 1 },
  targets: { gutter: 16, column: 1 },
  sizes: { gutter: 16, column: 4 },
  default: { gutter: 16, column: 2 },
};

export const tagClassNames = {
  colors: 'colorCheckableTag',
  sizes: 'sizeCheckableTag',
  default: '',
};

export const filterColors = {
  C01: '#000000', // black
  C02: '#fff', // white
  C03: '#800080', // purple
  C04: '#f892d6', // pink
  C05: '#8e0000', // burdeos
  C06: '#db2415', // red
  C07: '#2801f6', // blue
  C08: '#ff7000', // orange
  C09: '#e9d8cc', // beige
  C10: '#18b000', // green
  C11: '#783600', // brown
  C12: '#fbe401', // yellow
  C13: '#bcb9b9', // grey
  C14: 'linear-gradient(0deg, rgba(34,193,195,1) 0%, rgba(253,187,45,1) 100%)', // multicolor
  C16: '#f3d3b7', // nude
  C17: '#3d3635', // brown grey
};
